export type ClauseCardVariant = "original" | "client" | "ai";

export type ClauseCardProps = {
  readonly title: string;
  readonly body: string;
  readonly selected: boolean;
  readonly subtitle?: string;
  readonly onSelect?: () => void;
};

export const ClauseCard = ({
  title,
  body,
  selected,
  subtitle,
  onSelect,
}: ClauseCardProps) => {
  const interactive = typeof onSelect === "function";
  return (
    <div
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      className={`rounded-lg border bg-muted/40 p-3 text-left transition-all duration-200 ease-in-out ${
        selected ? "border-primary ring-1 ring-primary" : "border-border"
      } ${interactive ? "cursor-pointer hover:bg-muted/60" : ""}`}
      onClick={() => onSelect?.()}
      onKeyDown={(e) => {
        if (!interactive) {
          return;
        }
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect?.();
        }
      }}
    >
      <div className="flex flex-wrap items-baseline gap-2">
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        {subtitle ? (
          <span className="text-xs font-normal text-muted-foreground">
            {subtitle}
          </span>
        ) : null}
      </div>
      <p
        className="mt-2 whitespace-pre-wrap text-sm bg-gray-100 border border-border p-2 rounded-md leading-relaxed text-foreground"
        style={{ maxHeight: "200px", overflow: "auto" }}
      >
        {body}
      </p>
    </div>
  );
};
